var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        id: "Layer_53",
        xmlns: "http://www.w3.org/2000/svg",
        width: "100",
        height: "100",
        viewBox: "0 0 100 100",
      },
    },
    [
      _c("path", {
        staticStyle: {
          fill: "none",
          stroke: "#000",
          "stroke-miterlimit": "10",
          "stroke-width": "2px",
        },
        attrs: {
          d: "m73.36,69.6c-.39,7.14-2.98,13.95-8.63,18.85h-29.46c-5.65-4.9-8.24-11.71-8.63-18.85-.15-2.71.01-5.48.45-8.2,1.444-9.033,7.821-16.01,16.08-18.767,1.21-.404,2.055-1.496,2.09-2.771l.753-27.339c.015-.541.458-.972,1-.972h5.974c.542,0,.985.431,1,.972l.753,27.339c.035,1.275.88,2.368,2.09,2.771,8.259,2.757,14.637,9.734,16.08,18.767.44,2.72.6,5.49.45,8.2Z",
        },
      }),
      _c("line", {
        staticStyle: {
          fill: "none",
          stroke: "#000",
          "stroke-miterlimit": "10",
          "stroke-width": "2px",
        },
        attrs: { x1: "46.3", y1: "17.219", x2: "54.7", y2: "17.219" },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }